import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { RequestHeaderModel } from '../models/request-header.model';
import { RichDataModel } from '../models/rich-data.model';
import { CaptionPipe } from '../pipes/caption.pipe';
import { AccommodationService } from './accommodation.service';
import { DataService } from './data.service';
import { GetTranslationService } from './get-translation.service';
import { ModalMakerService } from './modal-maker.service';
import { ToastMachineService } from './toast-machine.service';
import { SalesHeader } from '../models/sales-header.model';
import { ExternalRequestModel } from '../models/external-request.model';
import { AuthService } from './auth.service';
import * as dayjs from 'dayjs';

@Injectable({
  providedIn: 'root',
})
export class RequestService {
  constructor(
    private http: HttpClient,
    private toaster: ToastMachineService,
    private translator: GetTranslationService,
    private caption: CaptionPipe,
    private modalServ: ModalMakerService,
    private accomServ: AccommodationService,
    private dataServ: DataService,
    private authServ: AuthService
  ) {}

  postrequest(
    request: RequestHeaderModel[]
  ): Promise<RequestHeaderModel[] | { message: string }> {
    return new Promise(async (resolve, reject) => {
      if (
        this.dataServ.rData &&
        this.dataServ.menuItem &&
        !this.dataServ.menuItem.accommodation_is_not_required
      ) {
        await this.accomServ.controlVisits();
      }

      const VISITS = await this.accomServ.getVisits(this.authServ.profile.id);

      request.forEach((req) => {
        VISITS?.forEach((visit) => {
          if (
            dayjs(new Date()).diff(visit.end_date) < 0 &&
            dayjs(new Date()).diff(visit.start_date) > 0
          ) {
            req.room_no = visit?.room_no;
          }
        });
      });

      // await this.modalServ.locationMandatoryChecker();

      this.http.post(environment.apiURL + '/request', request).subscribe({
        next: async (resp: RequestHeaderModel[] | any) => {
          if (resp.payment_type != 'Online') {
            if (resp instanceof Array) {
              const MSG = await this.translator.getTranslate(
                'We have successfully received your request.'
              );
              this.toaster.toastMachine(MSG, 'primary', 3000);
              resolve(resp);
            } else {
              this.toaster.toastMachine(
                this.caption.transform(resp.message) ||
                  this.caption.transform(resp),
                'danger',
                3000
              );
              reject();
            }
          } else {
            if (resp instanceof Array) {
              const MSG = await this.translator.getTranslate(
                'Redirecting to payment gateway.'
              );
              this.toaster.toastMachine(MSG, 'primary', 3000);
              resolve(resp);
            } else {
              this.toaster.toastMachine(
                this.caption.transform(resp.message) ||
                  this.caption.transform(resp),
                'danger',
                3000
              );
              reject();
            }
          }
        },
        error: (err) => {
          const error =
            err.error && err.error.message ? err.error.message : err.message;
          this.toaster.toastMachine(error, 'danger', 3000);
          reject(err);
        },
      });
    });
  }

  exapiPostrequest(
    request: ExternalRequestModel
  ): Promise<ExternalRequestModel | { message: string }> {
    return new Promise(async (resolve, reject) => {
      this.http.post(environment.exApiURL + '/request', request).subscribe({
        next: async (resp: ExternalRequestModel) => {
          const MSG = await this.translator.getTranslate(
            'We have successfully received your request.'
          );
          this.toaster.toastMachine(MSG, 'primary', 3000);
          resolve(resp);
        },
        error: (err) => {
          const error =
            err.error && err.error.message ? err.error.message : err.message;
          this.toaster.toastMachine(error, 'danger', 3000);
          reject(err);
        },
      });
    });
  }

  putRequest(request: RequestHeaderModel): Promise<RequestHeaderModel> {
    return new Promise((resolve, reject) => {
      this.http.put(environment.apiURL + '/request', request).subscribe({
        next: async (resp: RequestHeaderModel) => {
          resolve(resp);
        },
        error: (err) => {
          const error =
            err.error && err.error.message ? err.error.message : err.message;
          this.toaster.toastMachine(error, 'danger', 3000);
          reject(err);
        },
      });
    });
  }

  getRequestById(requestId: number): Promise<RequestHeaderModel> {
    return new Promise((resolve, reject) => {
      this.http.get(environment.apiURL + '/request/' + requestId).subscribe({
        next: (resp: RequestHeaderModel) => {
          resolve(resp);
        },
        error: (err) => {
          const error =
            err.error && err.error.message ? err.error.message : err.message;
          this.toaster.toastMachine(error, 'danger', 3000);
          reject(err);
        },
      });
    });
  }

  getOrders(profileId: number): Promise<RequestHeaderModel[]> {
    return new Promise((resolve, reject) => {
      this.http
        .get(environment.apiURL + '/request_by_profile_id/' + profileId)
        .subscribe({
          next: (resp: RequestHeaderModel[]) => {
            resolve(resp);
          },
          error: (err) => {
            const error =
              err.error && err.error.message ? err.error.message : err.message;
            this.toaster.toastMachine(error, 'danger', 3000);
            reject(err);
          },
        });
    });
  }

  getPaymentProvider(): Promise<{
    name:
      | 'Stripe'
      | 'Genesis'
      | 'Garanti'
      | 'PAYTR'
      | 'GPEPay'
      | 'BULUTTahsilat';
  }> {
    return new Promise((resolve) => {
      this.http.get(environment.apiURL + '/payment_provider_type').subscribe({
        next: (data: { name: 'Stripe' | 'Genesis' | 'Garanti' | 'PAYTR' }) => {
          resolve(data);
        },
        error: () => {
          resolve(null);
        },
      });
    });
  }

  sendGym(reqData: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.post(environment.apiURL + '/bulut_gym', reqData).subscribe({
        next: (resp: any) => {
          this.toaster.toastMachine(
            this.caption.transform('Qr code successfully generated'),
            'primary',
            3000
          );
          resolve(resp);
        },
        error: (err) => {
          const error =
            err.error && err.error.message ? err.error.message : err.message;
          this.toaster.toastMachine(
            'Please check your login information and try again',
            'danger',
            3000
          );
          reject(err);
        },
      });
    });
  }

  sendSale(reqData: SalesHeader): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.post(environment.apiURL + '/sales_payment', reqData).subscribe({
        next: (resp: { pay_url: string }) => {
          resolve(resp);
        },
        error: (err) => {
          const error =
            err.error && err.error.message ? err.error.message : err.message;
          this.toaster.toastMachine(error, 'danger', 3000);
          reject(err);
        },
      });
    });
  }

  getBasket(basket): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(environment.URL + '/exapi/basket/calculate', basket)
        .subscribe({
          next: (resp) => {
            resolve(resp);
          },
          error: (err) => {
            const error =
              err.error && err.error.message ? err.error.message : err.message;
            this.toaster.toastMachine(error, 'danger', 3000);
            reject(err);
          },
        });
    });
  }
}
